import React from "react";

import LoginForm from "./login-form";

const Login = () => {
  return <LoginForm />;
};

export default Login;
